export function authoringErrorMessage(reason: unknown) {
  if (reason instanceof Error) return reason.message;
  if (reason && typeof reason === "object") {
    if ("message" in reason && typeof reason.message === "string") return reason.message;
    try { return JSON.stringify(reason); } catch { /* fall through */ }
  }
  return String(reason);
}
